
import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2 } from "lucide-react";
import type { CartItem as CartItemType } from "@/context/CartContext";
import { useIsMobile } from "@/hooks/use-mobile";

interface CartItemProps {
  item: CartItemType;
  onQuantityChange: (itemId: string, change: number) => void;
  onRemoveItem: (itemId: string) => void;
}

export const CartItem = ({ item, onQuantityChange, onRemoveItem }: CartItemProps) => {
  const isMobile = useIsMobile();
  
  // Fonction pour formater l'affichage de la variante
  const formatVariantText = (variant: CartItemType['variant']) => {
    const size = variant.size || 'unique';
    const colorName = variant.colorName || 'standard';
    return `${size} - ${colorName}`;
  };

  return (
    <div className="p-3 sm:p-6 border-b last:border-b-0 border-zinc-100">
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-6">
        <div className="w-full sm:w-24 h-24 sm:h-24 rounded-lg overflow-hidden bg-zinc-50 flex-shrink-0">
          <img
            src={item.image}
            alt={item.name}
            className="w-full h-full object-cover hover:scale-105 transition-transform"
          />
        </div>
        <div className="flex-grow min-w-0">
          <div className="flex justify-between mb-1 sm:mb-2">
            <h3 className="font-medium text-zinc-900 truncate pr-2 sm:pr-4 text-sm sm:text-base">{item.name}</h3>
            <span className="font-medium text-[#b82626] text-sm sm:text-base whitespace-nowrap">{item.price.toFixed(2)} CAD</span>
          </div>
          <p className="text-xs sm:text-sm text-zinc-500 mb-3 sm:mb-4">
            {formatVariantText(item.variant)}
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="icon"
                className="h-7 w-7 sm:h-8 sm:w-8 hover:bg-zinc-50"
                onClick={() => onQuantityChange(item.id, -1)}
              >
                <Minus className="w-3 h-3" />
              </Button>
              <span className="w-7 sm:w-8 text-center text-xs sm:text-sm font-medium text-zinc-900">{item.quantity}</span>
              <Button
                variant="outline"
                size="icon"
                className="h-7 w-7 sm:h-8 sm:w-8 hover:bg-zinc-50"
                onClick={() => onQuantityChange(item.id, 1)}
              >
                <Plus className="w-3 h-3" />
              </Button>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemoveItem(item.id)}
              className="text-zinc-400 hover:text-[#b82626] hover:bg-zinc-50 self-start sm:self-auto p-0 sm:p-2 h-auto"
            >
              <Trash2 className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
              <span className="text-xs sm:text-sm">Retirer</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
